/**
 * Upload capability (src/platform/).
 *
 * Contract: every capability has a working web implementation; native
 * branches (via isNativePlatform()) are added in #981 and MUST keep the
 * web fallback. This is the platform seam for uploads: web and native
 * both use the resumable chunked server API via useMediaUploadStore; a
 * future native background-uploader plugin is an optimization behind
 * this same function.
 */

import { useMediaUploadStore } from '@/stores/useMediaUploadStore'

/** Queue files into the resumable chunked uploader (fire-and-forget). */
export function enqueueUploads(files: File[]): void {
  void useMediaUploadStore.getState().addFiles(files)
}

/** Start one file up through the resumable chunked uploader for a chat message, which
 * attaches it once it is stored; its upload id (the asset id it becomes), or null when it
 * could not start. The message's tile shows its progress, not the tray. */
export async function startUpload(file: File): Promise<string | null> {
  const store = useMediaUploadStore.getState()
  const [uploadId] = await store.addFiles([file])
  if (uploadId) store.holdForMessage(uploadId, true)
  return uploadId ?? null
}
